var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tubber-layout layout layout--campaign"},[_c('header-container'),_c('nuxt',{class:[("page--" + (_vm.$store.state.appTheme) + "-theme"), ("page--" + (_vm.$route.name))]}),_c('login-modal'),_c('register-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }